import { z } from 'zod'

export const MarketMakerDataCoinSchema = z.object({
  id: z.string(),
  name: z.string(),
  symbol: z.string(),
  image: z.string().nullable(),
})

export const GetMarketMakerDataCoinsResponseBody = z.array(MarketMakerDataCoinSchema)

export type MarketMakerDataCoinType = z.infer<typeof MarketMakerDataCoinSchema>

export const MarketMakerDataExchangeSchema = z.object({
  id: z.string(),
  name: z.string(),
  image: z.string().nullable(),
  coingeckoId: z.string(),
  coingeckoName: z.string(),
  isSpotExchange: z.boolean().nullable(),
  isDerivativesExchange: z.boolean().nullable(),
})

export const GetMarketMakerDataExchangesResponseBody = z.array(MarketMakerDataExchangeSchema)

export type MarketMakerDataExchangeType = z.infer<typeof MarketMakerDataExchangeSchema>
